module.exports = __webpack_public_path__ + "static/media/mongoDB.bf4b640c.png";